import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="5226" className="flex gap-8">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-white/5 animate-pulse rounded-none" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-[12px] font-medium uppercase tracking-[0.2em] text-foreground hover:text-primary border-b border-transparent hover:border-primary transition-all duration-300 block py-1">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 p-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-6 w-32 bg-white/5 animate-pulse rounded-none" />)}
      </div>;
  }
  return <nav className="flex flex-col p-6 gap-6">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-base font-medium text-foreground hover:text-primary uppercase tracking-[0.2em] transition-colors" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function IntestazioneTecnica() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="navigazione-strategica" className={cn("dark sticky top-0 z-50 w-full transition-all duration-500 border-b", isScrolled ? "bg-[#050505]/70 backdrop-blur-xl border-white/5 shadow-none" : "bg-[#050505] border-transparent")}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-[88px]">
          {}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/HomePage" className="flex items-center">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591789/img/vostoka_premium_export_architecture_logo.png" alt="Votoka - Export e Sviluppo CSI" className="h-[32px] w-auto object-contain brightness-100" />
            </Link>
          </div>

          {}
          <div className="hidden md:flex items-center">
            <MenuProvider menu_id="16" className="flex">
              <DesktopMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex md:hidden">
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-foreground hover:bg-white/5 rounded-none" aria-label="Toggle menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      {}
      {isMobileMenuOpen && <div className="md:hidden absolute top-[89px] left-0 w-full bg-[#050505] border-b border-white/5 shadow-2xl animate-in slide-in-from-top-5 fade-in duration-300">
          <MenuProvider menu_id="16">
            <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
        </div>}
    </header>;
}